import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import HelpOutline from '@mui/icons-material/HelpOutline';
import {theme} from '../../../Theme';
import BidmiiRadio from '../../../common/StyledComponents/BidmiiRadio';
import BidmiiTooltip from '../../../common/StyledComponents/BidmiiTooltip';
import PrePackagedProjects from '../utils/PrePackagedProjects';
import {SCREEN_NAMES, fireScreenView} from '../../../util/Analytics';
import ActionButtons from '../components/ActionButtons';

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',
  },
  radioBox: {
    cursor: 'pointer',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 10,
    marginBottom: 8,
  },
  templateTitle: {
    width: 'fit-content',
    margin: '0 auto 16px',
    fontSize: 18,
  },
  templateCard: {
    cursor: 'pointer',
    // width: 165,
    height: 110,
    margin: '0 8px',
    borderRadius: 12,
    backgroundColor: theme.palette.gray.main,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    border: `1px solid ${theme.palette.secondary.main}`,

    '&:hover': {
      border: `1px solid ${theme.palette.primary.light}`,
    },
  },
}));

const ProjectSelectionStep = (props: $TSFixMe) => {
  useEffect(() => {
    fireScreenView(SCREEN_NAMES.NEW_PROJECT_WIZARD_PROJECT_SELECTION_STEP);
  }, []);

  const classes = useStyles();
  const history = useHistory();
  const [createProjectType, setCreateProjectType] = useState('scratch');

  const handleCreateCustomProject = () => {
    props.chooseProjectTemplate(null);
  };

  const handleClickTemplateCard = (template: $TSFixMe) => {
    props.chooseProjectTemplate(template);
  };

  return (
    <div className={classes.root}>
      <Grid container height="100%" justifyContent="center" alignItems="center">
        <div style={{width: '100%', maxWidth: 450}}>
          <Typography variant="h6" gutterBottom fontSize={22} fontWeight="bold">
            Getting started
          </Typography>
          <Box
            mt={3}
            p={1.5}
            onClick={() => setCreateProjectType('scratch')}
            className={classes.radioBox}
            style={{
              backgroundColor:
                createProjectType === 'scratch'
                  ? theme.palette.blue.light
                  : theme.palette.secondary.main,
              borderColor:
                createProjectType === 'scratch'
                  ? theme.palette.blue.dark
                  : theme.palette.gray.border,
            }}>
            <Grid container alignItems="center">
              <BidmiiRadio
                value="scratch"
                state={createProjectType}
                onChange={(e: any) => setCreateProjectType(e.target.value)}
                style={{marginTop: -8}}
              />
              <Typography variant="subtitle1" style={{fontSize: 18}}>
                Start from scratch
              </Typography>
            </Grid>
          </Box>

          <Box
            p={1.5}
            onClick={() => setCreateProjectType('designmii')}
            className={classes.radioBox}
            style={{
              backgroundColor:
                createProjectType === 'designmii'
                  ? theme.palette.blue.light
                  : theme.palette.secondary.main,
              borderColor:
                createProjectType === 'designmii'
                  ? theme.palette.blue.dark
                  : theme.palette.gray.border,
            }}>
            <Grid container alignItems="center">
              <BidmiiRadio
                value="designmii"
                state={createProjectType}
                onChange={(e: any) => setCreateProjectType(e.target.value)}
                style={{marginTop: -8}}
              />
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                fontSize={18}
                color={theme.palette.blue.main}>
                design
                <span style={{color: theme.palette.primary.main}}>mii</span>
                .&nbsp;
                <BidmiiTooltip
                  title={
                    'Powered by world class designers, Designmii is your all-in-one design package for renovations, exclusively available to Bidmii users. We offer a range of design packages to suit your needs, from mood boards to floor plans, elevations, and material selections.'
                  }>
                  <HelpOutline
                    fontSize="small"
                    style={{color: theme.palette.gray.dark}}
                  />
                </BidmiiTooltip>
              </Typography>
            </Grid>
          </Box>

          <Box
            p={1.5}
            onClick={() => setCreateProjectType('template')}
            className={classes.radioBox}
            style={{
              backgroundColor:
                createProjectType === 'template'
                  ? theme.palette.blue.light
                  : theme.palette.secondary.main,
              borderColor:
                createProjectType === 'template'
                  ? theme.palette.blue.dark
                  : theme.palette.gray.border,
            }}>
            <Grid container alignItems="center">
              <BidmiiRadio
                value="template"
                state={createProjectType}
                onChange={(e: any) => setCreateProjectType(e.target.value)}
                style={{marginTop: -8}}
              />
              <Typography variant="subtitle1" style={{fontSize: 18}}>
                Use a template
              </Typography>
            </Grid>
          </Box>

          {createProjectType === 'template' && (
            <Box my={3}>
              <Grid
                container
                justifyContent="center"
                style={{
                  maxHeight: 300,
                  overflowY: 'scroll',
                }}>
                {PrePackagedProjects.map((project) => (
                  <Grid item xs={6} key={project.key}>
                    <div
                      className={classes.templateCard}
                      onClick={() => handleClickTemplateCard(project.key)}
                      style={{
                        backgroundImage: `url(${project.image})`,
                      }}
                    />
                    <Grid
                      container
                      justifyContent="center"
                      style={{marginBottom: 20}}>
                      <Typography variant="subtitle2">
                        {project.prompt}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          <ActionButtons
            secondaryAction={props.handleClose}
            primaryAction={() =>
              createProjectType === 'scratch'
                ? handleCreateCustomProject()
                : history.push('/resources/designmii')
            }
            secondaryLabel="CANCEL"
            disabled={createProjectType === 'template'}
          />
        </div>
      </Grid>
    </div>
  );
};

export default ProjectSelectionStep;
